import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Loader2, Trash2 } from 'lucide-react';
import { Button } from '../../ui-v2';
import { Modal, Badge } from '../../ui-v2.5';

/**
 * EliminarModal — modal de BORRADO FÍSICO (§3.5b), compartido por las cuatro pantallas de configuración.
 * Distinto de "Desactivar" (reversible): esto es permanente. Modal de tono danger.
 *
 * - `children` describe QUÉ SE PIERDE (específico por entidad: miembros de un área, recursos y tareas de
 *   un perfil…), no solo que es irreversible.
 * - Si el backend responde 409 `tiene_dependencias`, el modal MUTA sin cerrarse y lista las dependencias
 *   con su tipo y etiqueta (igual que el bloqueo de desactivación).
 *
 * props: titulo · subtitulo · exitoMsg · eliminar():Promise · onClose · onEliminado
 */
const TIPO_LABEL = { recurso: 'Recurso', tarea: 'Tarea de perfil', regla: 'Regla de aviso', perfil: 'Perfil' };
const cuerpoError = (e) => (e && e.response && e.response.data) || {};

export default function EliminarModal({ titulo, subtitulo, exitoMsg, eliminar, onClose, onEliminado, children }) {
  const [procesando, setProcesando] = useState(false);
  const [bloqueo, setBloqueo] = useState(null); // dependencias[] si 409

  async function confirmar() {
    setProcesando(true);
    try {
      await eliminar();
      toast.success(exitoMsg || 'Eliminado permanentemente.');
      onEliminado();
    } catch (e) {
      const body = cuerpoError(e);
      if (body.error === 'tiene_dependencias') {
        setBloqueo(body.dependencias || []);
      } else {
        console.error('[incorp][eliminar]', e);
        toast.error(body.message || 'No se pudo eliminar.');
      }
    } finally {
      setProcesando(false);
    }
  }

  const footer = bloqueo ? (
    <Button variant="outline" onClick={onClose}>Entendido</Button>
  ) : (
    <>
      <Button variant="outline" onClick={onClose} disabled={procesando}>Cancelar</Button>
      <Button variant="destructive" onClick={confirmar} disabled={procesando}>
        {procesando ? <Loader2 className="animate-spin" /> : <Trash2 />}Eliminar definitivamente
      </Button>
    </>
  );

  return (
    <Modal
      open
      onClose={onClose}
      size="sm"
      tone="danger"
      title={bloqueo ? 'No se puede eliminar' : titulo}
      subtitle={subtitulo}
      footer={footer}
    >
      {bloqueo ? (
        <div className="space-y-3">
          <p className="text-sm text-v25-ink-700">
            No se puede eliminar: {bloqueo.length} elemento(s) dependen de este registro. Resuélvelos primero.
          </p>
          <ul className="divide-y divide-v25-line rounded-v25-md border border-v25-line">
            {bloqueo.map((d) => (
              <li key={`${d.tipo}:${d.id}`} className="flex items-center gap-2 px-3 py-2 text-sm text-v25-ink-800">
                <Badge tone="info">{TIPO_LABEL[d.tipo] || d.tipo}</Badge>
                <span className="truncate">{d.etiqueta}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="text-sm text-v25-ink-700">{children}</div>
      )}
    </Modal>
  );
}
